import $http from './index.js';
export const login= (data)=>{
    return $http.post('api/Login/Login',data)
    // return $http.get('http://jsonplaceholder.typicode.com/posts',data)
}
export const GetCurrentUser= (data)=>{
    return $http.post('api/User/GetCurrentUser',data)
}
export const LoginOut= (data)=>{
    return $http.post('api/Login/LoginOut',data)
}